let requestUrls = {
  enterpriseRecord:{
    dev:"/api1",
    pred:"https://tqjcrm.yxhf.net/qjcrm/",
    prod:"https://tqjcrm.yxhf.net/qjcrm/"
  },
  practitionersRegistration: {
    dev: "/api2",
    pred:"https://thuman.yxhf.net/organization/v2/",
    prod:"https://thuman.yxhf.net/organization/v2/"
  },
  imgUrl: {
    dev: "https://qjdev-pred-images.oss-cn-beijing.aliyuncs.com/merchant/",
    pred: "https://qjdev-pred-images.oss-cn-beijing.aliyuncs.com/merchant/",
    prod:"https://qjprod-images.oss-cn-beijing.aliyuncs.com/tsfzx_institution/"
  },
  institutionDetail: {
    dev: "/api3",
    pred: "https://tqjcrmapi.tsfzx.com/",
    prod: "https://tqjcrmapi.tsfzx.com/"
  },
  ossConfig:{
    dev: "https://a.allqj.com",
    pred: "https://a.allqj.com",
    prod: "https://a.allqj.com",
  }
}
export default (name) => {
  return requestUrls[name][process.env.REACT_APP_ENV]
}
